module.exports = __webpack_public_path__ + "img/dieDieDie.52cfeb62.png";